exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.titolo {\n    font-family: 'Libre Baskerville', serif;\n    font-style: italic;\n    font-size: 170%;\n    font-weight: 400;\n    margin-bottom: 0;\n    text-transform: none;\n}\n.mce-tinymce {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n}\n", ""]);

// exports
